<div class="modal-header">
    <h4 class="modal-title pull-left"> Create Supplemental Link </h4>
    <div aria-label="Close" (click)="onCancel()" class="close pull-right">
      <span aria-hidden="true">×</span></div>
  </div>

  <div class="modal-body">
    <label>Send Supplemental Link To:</label>
    <input type="text" class="form-control" placeholder="Please enter the contact’s email here" [(ngModel)]="emailId">
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-rbv" (click)="onSend()" >Send</button>
  </div>


